import styled from "styled-components";
import { FONT_WEIGHT } from "../../../constants/Styles";

export const VerticalList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
`;

export const PanelDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const BoardNotes = styled.div`
  display: flex;
  flex-direction: column;
`;
export const GridTable = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
`;

export const GridCard = styled.div<{
  highlight: boolean;
}>`
  padding: 0.75rem;
  border-radius: 6px;

  background-color: ${({ highlight }) => (highlight ? "#8b1e1e" : "#fafafa")};
  border: 1px solid ${({ highlight }) => (highlight ? "#8b0000" : "#e5e5e5")};
`;

export const CardLabel = styled.div<{ highlight: boolean }>`
  font-size: 0.8rem;
  color: ${({ highlight }) => (highlight ? "#fafafa" : "#666")};
  margin-bottom: 0.25rem;
`;

export const CardValue = styled.div<{ highlight: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.95rem;
  font-weight: ${({ highlight }) => (highlight ? 600 : 400)};
  color: ${({ highlight }) => (highlight ? "#fafafa" : "#111")};
`;

export const TitleWarning = styled.div`
  display: flex;
  align-items: center;
`;

export const PartOrContainerTypeWarning = styled.li`
  font-weight: ${FONT_WEIGHT.weight700};
`;

export const PartWarningsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
`;

export const StencilDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;
